import React from "react";

const ProjectCardItem = ({ elipseImage, value = 0, label, typeOfData }) => {
    return (
        <div className="w-16  flex flex-col flex-wrap ">
            <img src={elipseImage} alt="" className="w-6 h-6 mx-auto" />
            <div className=" flex flex-col grow pt-1">
                <p className="text-xs font-bold text-center text-[#282828]">{value}</p>
                <p className="text-[7px] font-normal  text-center text-[#686868]">{label}</p>
                <div className="w-full text-xs grow pt-1  ">
                    <p className="text-[#282828] text-center text-[10px] font-normal leading-normal">{typeOfData}</p>
                </div>
            </div>
        </div>
    );
};

export default ProjectCardItem;
